<div class="form-element subtitle-section my-15">
  <p>{{ referenceDataLabels.Employment | localizeLabel }}</p>
</div>
<boi-form-information-box [message]="referenceDataLabels.EmploymentStatusInformation"></boi-form-information-box>
<!-- 72 -->
<boi-form-option-list
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [labelName]="referenceDataLabels.EmploymentStatusId"
  [(value)]="employment.EmploymentStatusCode"
  [propertyNames]="[
    'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.EmploymentStatusCode'
  ]"
  [optionList]="referenceDataOptionLists.EmploymentStatus"
  [contextualHelpName]="referenceDataContextualHelps.EmploymentStatusCode"
  (valueChange)="onEmploymentStatusChanged()"
>
</boi-form-option-list>
<ng-container *ngIf="employment.isEmployed()">
  <!-- 74 -->
  <boi-form-option-list
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.TypeOfEmploymentId"
    [(value)]="employment.EmploymentTypeCode"
    [propertyNames]="[
      'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.EmploymentTypeCode'
    ]"
    [optionList]="referenceDataOptionLists.EmploymentType"
    [contextualHelpName]="referenceDataContextualHelps.EmploymentTypeCode"
    (valueChange)="onEmploymentTypeChanged()"
  >
  </boi-form-option-list>
</ng-container>
<ng-container *ngIf="areEmploymentTypeDetailsVisible()">
  <!-- 74.1 -->
  <boi-form-textarea
    class="big-textarea"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.PleaseProvideDetails"
    [(value)]="employment.EmploymentTypeDetails"
    [propertyNames]="[
      'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.EmploymentTypeDetails'
    ]"
    [fieldMaxLength]="1500"
  >
  </boi-form-textarea>
</ng-container>
<ng-container *ngIf="!mortgageApplication.IsAip">
  <ng-container *ngIf="employment.isEmployedButNotAsContractor()">
    <!-- 73 -->
    <boi-form-radio-button
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.DoYouOwn25OrMoreOfSharesInYouId"
      [(value)]="employment.Owns25PercentOfBusinessCode"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.Owns25PercentOfBusinessCode'
      ]"
      [optionList]="referenceDataOptionLists.AnswerType"
      (valueChanged)="onOwns25PercentOfBusinessChanged()"
    >
    </boi-form-radio-button>
    <ng-container *ngIf="employment.Owns25PercentOfBusinessCode === referenceDataOptionLists.AnswerTypeYes">
      <boi-form-information-box
        [decoration]="'exclamation-mark'"
        [message]="referenceDataLabels.SelfEmplyedWarning"
        [includeOkButton]="true"
      ></boi-form-information-box>
    </ng-container>
  </ng-container>
</ng-container>
<ng-container *ngIf="mortgageApplication.IsFullApp">
  <ng-container *ngIf="employment.isEmployed()">
    <!-- 75.1 -->
    <boi-form-text-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.NameOfEmployerId"
      [(value)]="employment.NameOfEmployer"
      [fieldMaxLength]="30"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.NameOfEmployer'
      ]"
    >
    </boi-form-text-input>
  </ng-container>
  <ng-container *ngIf="employment.isSelfEmployed()">
    <!-- 75.2 -->
    <boi-form-text-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.BusinessName"
      [(value)]="employment.NameOfEmployer"
      [fieldMaxLength]="30"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.NameOfEmployer'
      ]"
    >
    </boi-form-text-input>
  </ng-container>
  <ng-container *ngIf="employment.isEmployed() || employment.isSelfEmployed()">
    <boi-form-address
      [addressLine1Required]="true"
      [labelName]="
        employment.isEmployed() ? referenceDataLabels.AddressOfEmployerId : referenceDataLabels.BusinessAddress
      "
      [(address)]="employment.EmployerAddress"
      [propertyName]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.EmployerAddress'
      ]"
      [mortgageApplication]="mortgageApplication"
      [showCountryCode]="true"
      [isFindAddressButtonDisabled]="mortgageApplication?.IsApplicationReadOnly"
    >
    </boi-form-address>
  </ng-container>
  <ng-container *ngIf="employment.isEmployedButNotAsContractor()">
    <boi-form-checkbox
      (click)="clearHRAddress()"
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [controlId]="referenceDataLabels.HasDifferentHRAddress"
      [checkboxLabel]="referenceDataLabels.HasDifferentHRAddress | localizeLabel"
      [(value)]="employment.HasDifferentHRAddress"
      [trueValue]="referenceDataOptionLists.AnswerTypeYes"
      [falseValue]="undefined"
    >
    </boi-form-checkbox>
    <ng-container *ngIf="employment.HasDifferentHRAddress === referenceDataOptionLists.AnswerTypeYes">
      <boi-form-address
        [mortgageApplication]="mortgageApplication"
        [labelName]="referenceDataLabels.HRAddress"
        [addressLine1Required]="true"
        [(address)]="employment.HRAddress"
        [propertyName]="['Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.HRAddress']"
        [hideFindAddress]="false"
        [showCountryCode]="true"
        [isFindAddressButtonDisabled]="mortgageApplication?.IsApplicationReadOnly"
      >
      </boi-form-address>
    </ng-container>
    <boi-form-text-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.EmployeeNumberId"
      [(value)]="employment.EmployeeNumber"
      [fieldMaxLength]="30"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.EmployeeNumber'
      ]"
    >
    </boi-form-text-input>
  </ng-container>
  <ng-container *ngIf="employment.isEmployedOrSelfEmployed()">
    <boi-form-text-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.TaxReferenceNumber"
      [(value)]="employment.TaxReferenceNumber"
      [fieldMaxLength]="30"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.TaxReferenceNumber'
      ]"
    >
    </boi-form-text-input>
  </ng-container>
</ng-container>
<ng-container *ngIf="employment.isSelfEmployed()">
  <!-- 87 & 88 -->
  <boi-form-term-input
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.BusinessYearsInEmployment"
    [(years)]="employment.YearsInEmployment"
    [(months)]="employment.MonthsInEmployment"
    [propertyNames]="[
      'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.YearsInEmployment',
      'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.MonthsInEmployment'
    ]"
  >
  </boi-form-term-input>
</ng-container>
<ng-container *ngIf="!mortgageApplication.IsFactFind">
  <ng-container *ngIf="employment.isEmployedButNotAsContractor()">
    <!-- 85 & 86 -->
    <boi-form-term-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.HowLongHaveYouWorkedForThisEmpId"
      [(years)]="employment.YearsInEmployment"
      [(months)]="employment.MonthsInEmployment"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.YearsInEmployment',
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.MonthsInEmployment'
      ]"
    >
    </boi-form-term-input>
  </ng-container>
  <ng-container *ngIf="allPreviousEmployersWithin12MonthsDetailsVisible()">
    <!-- 86.1 -->
    <boi-form-textarea
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.AllPreviousEmployersWithin12MonthsDetails"
      [(value)]="employment.AllPreviousEmployersWithin12MonthsDetails"
      [propertyNames]="[
        'Applicant_' +
          applicantIndex +
          '.ApplicantEmployment' +
          '_' +
          employmentIndex +
          '.AllPreviousEmployersWithin12MonthsDetails'
      ]"
      [fieldMaxLength]="1500"
    >
    </boi-form-textarea>
  </ng-container>
</ng-container>
<ng-container *ngIf="mortgageApplication.IsFullApp">
  <ng-container *ngIf="isAbleToSupplyPayslipsVisible()">
    <!-- 86.2 -->
    <boi-form-radio-button
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.IsAbleToSupplyPayslips"
      [(value)]="employment.IsAbleToSupplyPayslips"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.IsAbleToSupplyPayslips'
      ]"
      [optionList]="referenceDataOptionLists.AnswerType"
    >
    </boi-form-radio-button>
  </ng-container>
  <ng-container *ngIf="employment.isEmployedButNotAsContractor() || employment.isSelfEmployed()">
    <!-- 89 -->
    <boi-form-text-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.WhatIsTheNatureOfTheBusinessId"
      [(value)]="employment.NatureOfBusiness"
      [fieldMaxLength]="30"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.NatureOfBusiness'
      ]"
    >
    </boi-form-text-input>
  </ng-container>
</ng-container>
<ng-container *ngIf="employment.isEmployedAsContractor()">
  <ng-container *ngIf="mortgageApplication.isResidential || isLoanGroupTypeBtlAffordability()">
    <!-- 90 -->
    <boi-form-numeric-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.GrossAnnualContractIncome"
      [(value)]="employment.GrossAnnualContractIncome"
      (valueChange)="updateTotalIncome()"
      [isCurrency]="true"
      [fieldMaxLength]="7"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.GrossAnnualContractIncome'
      ]"
    >
    </boi-form-numeric-input>
  </ng-container>
  <!-- 90.1 -->
  <boi-form-date
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.ContractEndDate"
    [(value)]="employment.ContractEndDate"
    [propertyNames]="[
      'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.ContractEndDate'
    ]"
  >
  </boi-form-date>
  <!-- 90.2 & 90.3 -->
  <boi-form-term-input
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.HowLongHaveYouBeenInThisSectorAsContractor"
    [(years)]="employment.YearsExperienceInSectorAsContractor"
    [(months)]="employment.MonthsExperienceInSectorAsContractor"
    [propertyNames]="[
      'Applicant_' +
        applicantIndex +
        '.ApplicantEmployment' +
        '_' +
        employmentIndex +
        '.YearsExperienceInSectorAsContractor',
      'Applicant_' +
        applicantIndex +
        '.ApplicantEmployment' +
        '_' +
        employmentIndex +
        '.MonthsExperienceInSectorAsContractor'
    ]"
  >
  </boi-form-term-input>
  <ng-container *ngIf="allPreviousEmployersOfContractorWithin12MonthsDetailsVisible()">
    <boi-form-textarea
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.AllPreviousEmployersWithin12MonthsDetails"
      [(value)]="employment.AllPreviousEmployersWithin12MonthsDetails"
      [propertyNames]="[
        'Applicant_' +
          applicantIndex +
          '.ApplicantEmployment' +
          '_' +
          employmentIndex +
          '.AllPreviousEmployersWithin12MonthsDetails'
      ]"
      [fieldMaxLength]="1500"
    >
    </boi-form-textarea>
  </ng-container>
</ng-container>
<ng-container *ngIf="employment.isEmployedOrSelfEmployed()">
  <!-- 91.1 -->
  <boi-form-option-list
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.Occupation"
    [(value)]="employment.OccupationCode"
    [propertyNames]="[
      'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.OccupationCode'
    ]"
    [optionList]="referenceDataOptionLists.Occupation"
  >
  </boi-form-option-list>
</ng-container>
<ng-container *ngIf="employment.isNotUnemployed()">
  <div class="vo-separator-line my-15"></div>
  <div class="form-element subtitle-section my-15">{{ referenceDataLabels.IncomeId | localizeLabel }}</div>
</ng-container>
<ng-container
  *ngIf="
    (mortgageApplication.isResidential || isLoanGroupTypeBtlAffordability()) &&
    employment.isEmployedButNotAsContractor()
  "
>
  <!-- 92 -->
  <boi-form-numeric-input
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.AnnualBasicSalaryIncludingAnyGId"
    [(value)]="employment.AnnualSalary"
    (valueChange)="updateTotalIncome()"
    [isCurrency]="true"
    [fieldMaxLength]="7"
    [propertyNames]="['Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.AnnualSalary']"
    [contextualHelpName]="
      mortgageApplication.isAdvisedCase
        ? referenceDataContextualHelps.AdvisedAppAnnualBasicSalary
        : referenceDataContextualHelps.AppAnnualBasicSalary
    "
  >
  </boi-form-numeric-input>
  <!-- 93 -->
  <boi-form-numeric-input
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.NonGuaranteedBonus"
    [(value)]="employment.NonGuaranteedBonus"
    (valueChange)="updateTotalIncome()"
    [isCurrency]="true"
    [fieldMaxLength]="7"
    [propertyNames]="[
      'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.NonGuaranteedBonus'
    ]"
    [contextualHelpName]="
      mortgageApplication.isAdvisedCase
        ? referenceDataContextualHelps.AdvisedAppAnnualBasicSalary
        : referenceDataContextualHelps.AppAnnualBasicSalary
    "
  >
  </boi-form-numeric-input>
</ng-container>
<ng-container
  *ngIf="
    (mortgageApplication.isResidential || mortgageApplication.isBuyToLet) &&
    !isLoanGroupTypeBtlAffordability() &&
    shouldShowTotalAnnualIncomePreviousYear()
  "
>
  <!-- 96 -->
  <boi-form-numeric-input
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]="referenceDataLabels.WhatWasYourEarnedGrossIncomeFoId"
    [(value)]="employment.TotalAnnualIncomePreviousYear"
    [isCurrency]="true"
    [fieldMaxLength]="7"
    [propertyNames]="[
      'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.TotalAnnualIncomePreviousYear'
    ]"
    [contextualHelpName]="
      mortgageApplication.isBuyToLet
        ? referenceDataContextualHelps.AppEarnedGrossIncomeBtl
        : referenceDataContextualHelps.AppEarnedGrossIncomeResidential
    "
  >
  </boi-form-numeric-input>
</ng-container>
<ng-container *ngIf="mortgageApplication.isResidential || isLoanGroupTypeBtlAffordability()">
  <ng-container *ngIf="employment.isEmployedOrSelfEmployed()">
    <!-- 97 -->
    <boi-form-numeric-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.WhatIsYourIntendedRetirementAgId"
      [(value)]="employment.IntendedRetirementAge"
      [fieldMaxLength]="2"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.IntendedRetirementAge'
      ]"
      (blurChange)="onIntendedRetirementAgeBlurChange()"
    >
    </boi-form-numeric-input>
  </ng-container>
  <ng-container
    *ngIf="mortgageApplication.IsFactFind && (isLoanGroupTypeBtlAffordability() || mortgageApplication.isResidential)"
  >
    <!-- 97.1 -->
    <boi-form-numeric-input
      [labelName]="referenceDataLabels.AgeAtMortgageTerm"
      [(value)]="applicant.AgeAtMortgageTerm"
      [isFieldDisabled]="true"
    >
    </boi-form-numeric-input>
  </ng-container>
  <ng-container *ngIf="isRetiredBeforeFinishLoan">
    <!-- 98 -->
    <boi-form-numeric-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.WhatIsYourTotalAnnualPensionInId"
      [(value)]="employment.TotalAnnualPensionIncomeExpected"
      [isCurrency]="true"
      [fieldMaxLength]="7"
      [propertyNames]="[
        'Applicant_' +
          applicantIndex +
          '.ApplicantEmployment' +
          '_' +
          employmentIndex +
          '.TotalAnnualPensionIncomeExpected'
      ]"
    >
    </boi-form-numeric-input>
  </ng-container>
  <ng-container
    *ngIf="!mortgageApplication.IsAip && (mortgageApplication.isResidential || isLoanGroupTypeBtlAffordability())"
  >
    <!-- 99 -->
    <boi-form-radio-button
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.EventsWhichAffectIncome"
      [(value)]="employment.EventsWhichAffectIncomeCode"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.EventsWhichAffectIncomeCode'
      ]"
      [optionList]="referenceDataOptionLists.AnswerType"
      [contextualHelpName]="referenceDataContextualHelps.AppFutureEvents"
    >
    </boi-form-radio-button>
    <ng-container *ngIf="employment.EventsWhichAffectIncomeCode === referenceDataOptionLists.AnswerTypeYes">
      <boi-form-textarea
        class="big-textarea"
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
        [labelName]="referenceDataLabels.DetailsOfChangeIncome"
        [(value)]="employment.DetailsOfChangeIncome"
        [propertyNames]="[
          'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.DetailsOfChangeIncome'
        ]"
        [fieldMaxLength]="1500"
      >
      </boi-form-textarea>

      <boi-form-textarea
        class="big-textarea"
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
        [labelName]="referenceDataLabels.WhatImpactWillThisHaveOnYourInId"
        [(value)]="employment.ImpactOnIncome"
        [propertyNames]="[
          'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.ImpactOnIncome'
        ]"
        [fieldMaxLength]="1500"
      >
      </boi-form-textarea>

      <boi-form-text-input
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
        [labelName]="referenceDataLabels.DateEffectOfAffectIncome"
        [(value)]="employment.DateEffectOfAffectIncome"
        [propertyNames]="[
          'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.DateEffectOfAffectIncome'
        ]"
      >
      </boi-form-text-input>
    </ng-container>
  </ng-container>
</ng-container>
<ng-container *ngIf="employment.isSelfEmployed()">
  <ng-container *ngIf="mortgageApplication.isResidential || isLoanGroupTypeBtlAffordability()">
    <!-- 103 -->
    <boi-form-radio-button
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.Has2YearsAccounts"
      [(value)]="employment.Has2YearsAccountsCode"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.Has2YearsAccountsCode'
      ]"
      [optionList]="referenceDataOptionLists.AnswerType"
    >
    </boi-form-radio-button>
    <!-- 103.1 -->
    <boi-form-text-input
      [digitsOnly]="true"
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.YearEnding1"
      [(value)]="employment.YearEnding1"
      [fieldMaxLength]="4"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.YearEnding1'
      ]"
    >
    </boi-form-text-input>
    <!-- 103.2 -->
    <boi-form-numeric-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.NetProfit1"
      [(value)]="employment.NetProfit1"
      [isCurrency]="true"
      (valueChange)="updateTotalIncome()"
      [fieldMaxLength]="7"
      [propertyNames]="['Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.NetProfit1']"
    >
    </boi-form-numeric-input>
    <!-- 103.4 -->
    <boi-form-text-input
      [digitsOnly]="true"
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.YearEnding2"
      [(value)]="employment.YearEnding2"
      [fieldMaxLength]="4"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.YearEnding2'
      ]"
    >
    </boi-form-text-input>
    <!-- 103.5 -->
    <boi-form-numeric-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.NetProfit2"
      [(value)]="employment.NetProfit2"
      [isCurrency]="true"
      (valueChange)="updateTotalIncome()"
      [fieldMaxLength]="7"
      [propertyNames]="['Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.NetProfit2']"
    >
    </boi-form-numeric-input>
    <!-- 104 -->
    <boi-form-numeric-input
      [isFieldDisabled]="true"
      [labelName]="referenceDataLabels.BusinessTotalAnnualIncomePreviousYear"
      [value]="employment.TotalAssessableIncome"
      [isCurrency]="true"
      [fieldMaxLength]="7"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.TotalAssessableIncome'
      ]"
    >
    </boi-form-numeric-input>
  </ng-container>

  <!-- 104.1 -->
  <ng-container *ngIf="mortgageApplication?.IsFullApp">
    <boi-form-numeric-input
      [labelName]="referenceDataLabels.CashEarningsPercentage"
      [(value)]="employment.CashEarningsPercentage"
      [isCurrency]="false"
      [fieldMaxLength]="3"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.CashEarningsPercentage'
      ]"
    >
    </boi-form-numeric-input>
  </ng-container>
</ng-container>

<ng-container *ngIf="mortgageApplication.IsFullApp">
  <ng-container
    *ngIf="mortgageApplication.isBuyToLet && !isLoanGroupTypeBtlAffordability() && employment.isSelfEmployed()"
  >
    <!-- 105 -->
    <boi-form-radio-button
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.HasAccountForPreviousFinancialYea"
      [(value)]="employment.HasAccountForPreviousFinancialYearCode"
      [propertyNames]="[
        'Applicant_' +
          applicantIndex +
          '.ApplicantEmployment' +
          '_' +
          employmentIndex +
          '.HasAccountForPreviousFinancialYearCode'
      ]"
      [optionList]="referenceDataOptionLists.AnswerType"
    >
    </boi-form-radio-button>
  </ng-container>
  <ng-container *ngIf="employment.isSelfEmployed()">
    <boi-form-radio-button
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      (valueChange)="onAccountantChange()"
      [labelName]="referenceDataLabels.HasAnAccountant"
      [(value)]="employment.HasAnAccountant"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.HasAnAccountant'
      ]"
      [optionList]="referenceDataOptionLists.AnswerType"
    >
    </boi-form-radio-button>
    <ng-container *ngIf="employment.HasAnAccountant === referenceDataOptionLists.AnswerTypeYes">
      <boi-form-text-input
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [labelName]="referenceDataLabels.AccountantsName"
        [(value)]="employment.AccountantsName"
        [fieldMaxLength]="40"
        [propertyNames]="[
          'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.AccountantsName'
        ]"
      >
      </boi-form-text-input>

      <boi-form-address
        [mortgageApplication]="mortgageApplication"
        [labelName]="referenceDataLabels.AccountantAddress"
        [addressLine1Required]="true"
        [(address)]="employment.AccountantAddress"
        [propertyName]="[
          'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.AccountantAddress'
        ]"
        [hideFindAddress]="false"
        [showCountryCode]="true"
        [isFindAddressButtonDisabled]="mortgageApplication?.IsApplicationReadOnly"
      >
      </boi-form-address>

      <boi-form-text-input
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [labelName]="referenceDataLabels.AccountantsPhoneNumber"
        [(value)]="employment.AccountantsPhoneNumber"
        [fieldMaxLength]="20"
        [propertyNames]="[
          'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.AccountantsPhoneNumber'
        ]"
      >
      </boi-form-text-input>

      <boi-form-text-input
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [labelName]="referenceDataLabels.AccountantsFaxNumber"
        [(value)]="employment.AccountantsFaxNumber"
        [fieldMaxLength]="20"
        [propertyNames]="[
          'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.AccountantsFaxNumber'
        ]"
      >
      </boi-form-text-input>
      <ng-container *ngIf="employment.ApplicantEmploymentAccountantTypes">
        <boi-form-checkbox-list
          [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
          [labelName]="referenceDataLabels.AccountantTypes"
          [(collection)]="employment.ApplicantEmploymentAccountantTypes"
          [rootPropertyName]="
            'Applicant_' +
            applicantIndex +
            '.ApplicantEmployment' +
            '_' +
            employmentIndex +
            '.ApplicantEmploymentAccountantType'
          "
          [propertyNames]="[
            'Applicant_' +
              applicantIndex +
              '.ApplicantEmployment' +
              '_' +
              employmentIndex +
              '.ApplicantEmploymentAccountantTypes'
          ]"
          [detailsLabelName]="referenceDataLabels.PleaseProvideDetails"
          [availableOptions]="referenceDataOptionLists.AccountantType | localizeOptionList"
          [codePropertyName]="'AccountantTypeCode'"
          [detailsPropertyName]="'AccountantTypeDetails'"
          [areDetailsRequired]="areDetailsRequiredForAccountantType"
        >
        </boi-form-checkbox-list>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
<ng-container *ngIf="mortgageApplication.isResidential || isLoanGroupTypeBtlAffordability()">
  <!-- 93b -->
  <boi-form-radio-button
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.AreYouInReceiptOfPensionCode"
    [(value)]="employment.AreYouInReceiptOfPensionCode"
    [propertyNames]="[
      'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.AreYouInReceiptOfPensionCode'
    ]"
    [optionList]="referenceDataOptionLists.AnswerType"
  >
  </boi-form-radio-button>
  <ng-container *ngIf="employment.AreYouInReceiptOfPensionCode === referenceDataOptionLists.AnswerTypeYes">
    <!-- 93c -->
    <boi-form-numeric-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.AnnualStatePension"
      [(value)]="employment.AnnualStatePension"
      [isCurrency]="true"
      [fieldMaxLength]="7"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.AnnualStatePension'
      ]"
      (valueChange)="updateTotalPension()"
    >
    </boi-form-numeric-input>
    <!-- 93d -->
    <div class="add-income-container">
      <div class="add-new-container vo-panel-grey p-15 d-flex my-15">
        <label class="form-label pr-10">{{ referenceDataLabels.AddNewPrivatePensionSource | localizeLabel }}</label>

        <button
          [disabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
          class="primary-button vo-secondary-button-1 mt-15n"
          (click)="addNewPrivatePensionSource()"
          [innerHtml]="referenceDataLabels.Add | localizeLabel"
        ></button>
      </div>
      <!-- 93e -->
      <ng-container *ngIf="employment.ApplicantEmploymentPrivatePensionSources?.length > 0">
        <div
          class="income-type vo-panel-grey p-15 px-md-0 d-flex my-15 flex-column"
          *ngFor="let pensionSource of employment.ApplicantEmploymentPrivatePensionSources; index as pensionSourceIndex"
        >
          <div class="flex-row d-flex flex-column-reverse flex-md-row justify-content-between mr-md-15">
            <boi-form-text-input
              [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
              [labelName]="referenceDataLabels.PrivatePensionSourceProvider"
              [(value)]="pensionSource.ProviderName"
              [fieldMaxLength]="30"
              [propertyNames]="[
                'Applicant_' +
                  applicantIndex +
                  '.ApplicantEmployment' +
                  '_' +
                  employmentIndex +
                  '.ApplicantEmploymentPrivatePensionSource_' +
                  pensionSourceIndex +
                  '.ProviderName'
              ]"
            >
            </boi-form-text-input>
            <button
              [disabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
              class="remove-button vo-icon vo-icon-recycle-bin cursor-pointer align-self-end align-self-md-start"
              (click)="removePrivatePensionSource(pensionSource)"
            ></button>
          </div>
          <boi-form-numeric-input
            [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
            [labelName]="referenceDataLabels.PrivatePensionSourceIncome"
            [(value)]="pensionSource.IncomeAmount"
            [isCurrency]="true"
            [fieldMaxLength]="7"
            [propertyNames]="[
              'Applicant_' +
                applicantIndex +
                '.ApplicantEmployment' +
                '_' +
                employmentIndex +
                '.ApplicantEmploymentPrivatePensionSource_' +
                pensionSourceIndex +
                '.IncomeAmount'
            ]"
            (valueChange)="updateTotalPension()"
          >
          </boi-form-numeric-input>
        </div>
      </ng-container>
    </div>
    <!-- 93f -->

    <boi-form-numeric-input
      [isFieldDisabled]="true"
      [labelName]="referenceDataLabels.TotalAnnualPrivatePension"
      [(value)]="employment.TotalAnnualPrivatePension"
      [isCurrency]="true"
      [fieldMaxLength]="7"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.TotalAnnualPrivatePension'
      ]"
    >
    </boi-form-numeric-input>
  </ng-container>

  <ng-container *ngIf="isFosteringAndMaintenanceVisible">
    <boi-form-numeric-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.FosteringIncome"
      [(value)]="employment.FosteringIncome"
      [isCurrency]="true"
      [fieldMaxLength]="7"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.FosteringIncome'
      ]"
      (valueChange)="updateTotalIncome()"
    >
    </boi-form-numeric-input>
    <boi-form-numeric-input
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.MaintenanceIncome"
      [(value)]="employment.MaintenanceIncome"
      [isCurrency]="true"
      [fieldMaxLength]="7"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.MaintenanceIncome'
      ]"
      (valueChange)="updateTotalIncome()"
    >
    </boi-form-numeric-input>
  </ng-container>
  <!-- 94 -->
  <boi-form-numeric-input
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.OtherRegularIncomeId"
    [(value)]="employment.OtherRegularIncome"
    [isCurrency]="true"
    [fieldMaxLength]="7"
    [propertyNames]="[
      'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.OtherRegularIncome'
    ]"
    (valueChange)="updateTotalIncome()"
  >
  </boi-form-numeric-input>
  <ng-container *ngIf="employment.OtherRegularIncome > 0">
    <!-- 95 -->
    <boi-form-textarea
      class="big-textarea"
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
      [labelName]="referenceDataLabels.SourceOfOtherRegularIncomeId"
      [(value)]="employment.OtherRegularIncomeSource"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.OtherRegularIncomeSource'
      ]"
      [fieldMaxLength]="1500"
    >
    </boi-form-textarea>
  </ng-container>
  <ng-container *ngIf="shouldDisplayTotalIncome">
    <!-- 95.1 -->
    <boi-form-numeric-input
      [labelName]="referenceDataLabels.TotalIncome"
      [value]="applicant.TotalIncome"
      [isCurrency]="true"
      [isFieldDisabled]="true"
    >
    </boi-form-numeric-input>
  </ng-container>
  <ng-container *ngIf="isLoanGroupTypeBtlAffordability() && mortgageApplication.IsFullApp">
    <!-- 96.1 -->
    <boi-form-option-list
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.CurrentMarginalTaxRateCode"
      [(value)]="employment.CurrentMarginalTaxRateCode"
      [propertyNames]="[
        'Applicant_' + applicantIndex + '.ApplicantEmployment' + '_' + employmentIndex + '.CurrentMarginalTaxRateCode'
      ]"
      [optionList]="referenceDataOptionLists.CurrentMarginalTaxRateCode"
    >
    </boi-form-option-list>
  </ng-container>
</ng-container>
<ng-container>
  <!-- 116.2 -->
  <ng-container *ngIf="mortgageApplication.IsFullApp">
    <boi-form-radio-button
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.HasIncomeFromOutsideUKCode"
      [(value)]="applicant.HasIncomeFromOutsideUKCode"
      [propertyNames]="['Applicant_' + applicantIndex + '.HasIncomeFromOutsideUKCode']"
      [optionList]="referenceDataOptionLists.AnswerType"
    >
    </boi-form-radio-button>
  </ng-container>

  <ng-container *ngIf="applicant.HasIncomeFromOutsideUKCode === referenceDataOptionLists.AnswerTypeYes">
    <!-- 116.3 & 116.4 -->
    <boi-form-income-outside-uk [(applicant)]="applicant" [(applicantIndex)]="applicantIndex">
    </boi-form-income-outside-uk>
  </ng-container>

  <ng-container *ngIf="shouldDisplayIncomePaymentCurrency()">
    <!-- 72.1 -->
    <boi-form-radio-button
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.IsAllIncomePaidInSterlingCode"
      [(value)]="employment.IsAllIncomePaidInSterlingCode"
      [propertyNames]="[
        'Applicant_' +
          applicantIndex +
          '.ApplicantEmployment' +
          '_' +
          employmentIndex +
          '.IsAllIncomePaidInSterlingCode'
      ]"
      [optionList]="referenceDataOptionLists.AnswerType"
    >
    </boi-form-radio-button>
  </ng-container>
  <ng-container *ngIf="mortgageApplication.IsFullApp">
    <!-- 116.1 -->
    <boi-form-checkbox-list
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.SourceOfWealth"
      [(collection)]="applicant.ApplicantSourceOfWealths"
      [rootPropertyName]="'Applicant_' + applicantIndex + '.ApplicantSourceOfWealth'"
      [propertyNames]="['Applicant_' + applicantIndex + '.ApplicantSourceOfWealths']"
      [detailsLabelName]="referenceDataLabels.SourceOfWealthDetails"
      [availableOptions]="referenceDataOptionLists.SourceOfWealth | localizeOptionList"
      [codePropertyName]="'SourceOfWealthCode'"
      [detailsPropertyName]="'SourceOfWealthDetails'"
      [areDetailsRequired]="areDetailsRequiredForSourceOfWealth"
    >
    </boi-form-checkbox-list>
  </ng-container>
</ng-container>
